import { Component, OnInit } from '@angular/core';

import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
} from '@angular/forms';
import { HttpClient } from '@angular/common/http';

import { VehicleService } from '../../../vehicles/services/vehicle.service';
import { DriversService } from '../../services/drivers.service';

import Swal from 'sweetalert2';

import { Md5 } from 'ts-md5';
import { Driver, TypeDocument } from '../../models/interfaces';

@Component({
  selector: 'app-drivers-modal',
  templateUrl: './drivers-modal.component.html',
  styleUrls: ['./drivers-modal.component.scss'],
})
export class DriversModalComponent implements OnInit {
  driversForm!: FormGroup;
  ibuttons: any = [];
  icipias: any = [];
  tipo_identificacion = '';

  public typeDocuments: TypeDocument[] = [
    { label: 'Código de Conductor', value: 'CODIGO' },
    { label: 'DNI', value: 'DNI' },
    { label: 'RUC', value: 'RUC' },
    { label: 'Carnet Extranjería', value: 'CARNET' },
    { label: 'Otro', value: 'OTRO' },
  ];

  public nroDocumentMaxLength: number = 0;
  public eyeStateCreate: boolean = true;
  public eyeStateEditBefore: boolean = true;
  public eyeStateEditAfter: boolean = true;
  public eyeStateEditAfter2: boolean = true;

  // Mensajes de error personalizados
  public errorMessages = {
    nombre: {
      required: 'El nombre completo es obligatorio',
    },
    dni: {
      required: 'El número de documento es obligatorio',
      minlength: 'El número de documento debe tener al menos 8 caracteres',
      maxlength: 'El número de documento no puede exceder los 8 caracteres',
      pattern: 'El número de documento debe contener solo números',
    },
    tipo_documento: {
      required: 'Debe seleccionar un tipo de documento',
    },
    nro_cellphone: {
      pattern: 'El número de teléfono debe contener solo números',
      minlength: 'El número de teléfono debe tener 9 dígitos',
      maxlength: 'El número de teléfono debe tener 9 dígitos',
    },
  };

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,

    public driversService: DriversService,
    public VehicleService: VehicleService
  ) {
    //this.loadData();
  }

  ngOnInit(): void {
    console.log('=========ngOnInit ');
    console.log(this.driversService.action);

    this.ibuttons = this.driversService.ibuttons;
    this.icipias = this.driversService.icipias;

    // Mostrar errores después de un pequeño delay para asegurar que el DOM esté listo
    setTimeout(() => {
      if (this.driversService.action !== 'edit') {
        this.showValidationErrors();
      }
    }, 100);

    if (this.driversService.action == 'edit') {
      //solo para el caso de EDIT su ibutton debe mostrarse
      var sub = this.driversService.drivers.filter(
        (item: Driver) => item.id == this.driversService.idDriverEdit
      );
      console.log('PRUEBA EDIT ->', sub);
      this.driversForm = this.fb.group({
        id: this.fb.control(sub[0].id),
        nombre: this.fb.control(sub[0].nombre_conductor, [Validators.required]),
        dni: this.fb.control(sub[0].dni_conductor, [Validators.required]),
        nro_llave: this.fb.control(sub[0].id_keyIbutton),
        nro_licencia: this.fb.control(sub[0].nro_licencia),
        nro_cipia: this.fb.control(sub[0].id_keyIcipia),
        nro_cellphone: this.fb.control(sub[0].telefono_conductor, [
          Validators.pattern(/^[0-9]+$/),
          Validators.minLength(9),
          Validators.maxLength(9),
        ]),
        tipo_identificacion: this.fb.control(sub[0].tipo_identificacion),
        tipo_documento: this.fb.control(sub[0].tipo_documento, [
          Validators.required,
        ]),
      });
      console.log(this.driversForm.value);
      // Configurar validaciones del documento para edición
      this.updateDocumentValidators(sub[0].tipo_documento || null);
    } else {
      this.driversForm = this.initForm();
    }

    // Suscribirse a cambios en tipo_documento para habilitar/deshabilitar dni
    this.driversForm.get('tipo_documento')?.valueChanges.subscribe((value) => {
      this.updateDocumentValidators(value);
    });
  }

  updateDocumentValidators(value: string | null | undefined): void {
    const dniControl = this.driversForm.get('dni');
    if (!dniControl) return;

    if (value) {
      dniControl.enable();
      const type = value.toUpperCase();
      let minLen = 1;
      let maxLen = 30;
      let pattern: RegExp = /^[a-zA-Z0-9\-_]+$/;
      let patternMsg = 'El código debe contener caracteres alfanuméricos';

      switch (type) {
        case 'DNI':
          minLen = 8;
          maxLen = 8;
          pattern = /^[0-9]+$/;
          patternMsg = 'El número de documento debe contener solo números';
          break;
        case 'RUC':
          minLen = 11;
          maxLen = 11;
          pattern = /^[0-9]+$/;
          patternMsg = 'El número de documento debe contener solo números';
          break;
        case 'CARNET':
          minLen = 1;
          maxLen = 12;
          pattern = /^[a-zA-Z0-9]+$/;
          patternMsg = 'El carnet debe contener caracteres alfanuméricos';
          break;
        case 'CODIGO':
          minLen = 1;
          maxLen = 30;
          pattern = /^[a-zA-Z0-9\-_]+$/;
          patternMsg = 'El código de conductor debe contener caracteres alfanuméricos';
          break;
        default:
          minLen = 1;
          maxLen = 30;
          pattern = /^[a-zA-Z0-9\-_]+$/;
          patternMsg = 'El documento debe contener caracteres alfanuméricos';
          break;
      }

      this.nroDocumentMaxLength = maxLen;
      this.errorMessages.dni.pattern = patternMsg;
      this.errorMessages.dni.minlength =
        minLen === maxLen
          ? `El número de documento debe tener ${minLen} dígitos`
          : `El número de documento debe tener al menos ${minLen} caracteres`;
      this.errorMessages.dni.maxlength =
        minLen === maxLen
          ? `El número de documento no puede exceder los ${maxLen} dígitos`
          : `El número de documento no puede exceder los ${maxLen} caracteres`;

      dniControl.setValidators([
        Validators.required,
        Validators.minLength(minLen),
        Validators.maxLength(maxLen),
        Validators.pattern(pattern),
      ]);
      dniControl.updateValueAndValidity();
    } else {
      dniControl.disable();
      dniControl.setValue(null);
      this.nroDocumentMaxLength = 0;
    }
  }

  getLengthDocument(value: string | null | undefined): number {
    // Validar que el valor no sea null o undefined
    if (!value) {
      return 30; // Valor por defecto
    }

    switch (value.toUpperCase()) {
      case 'DNI':
        return 8;
      case 'RUC':
        return 11;
      case 'CARNET':
        return 12;
      default:
        return 30;
    }
  }

  initForm(): FormGroup {
    return this.fb.group({
      id: this.fb.control(null),
      nombre: this.fb.control(null, [Validators.required]),
      dni: this.fb.control({ value: null, disabled: true }, [
        Validators.required,
      ]),
      nro_llave: this.fb.control(null),
      nro_cellphone: this.fb.control(null, [
        Validators.pattern(/^[0-9]+$/),
        Validators.minLength(9),
        Validators.maxLength(9),
      ]),
      nro_cipia: this.fb.control(null),
      nro_licencia: this.fb.control(null),
      tipo_identificacion: this.fb.control(null),
      tipo_documento: this.fb.control(null, [Validators.required]),
    });
  }

  // Método para obtener mensaje de error
  getErrorMessage(controlName: string): string {
    const control = this.driversForm.get(controlName);
    if (control && control.errors && control.touched) {
      const firstError = Object.keys(control.errors)[0];
      const errorMessages = this.errorMessages as any;
      return errorMessages[controlName]?.[firstError] || 'Campo inválido';
    }
    return '';
  }

  // Método para verificar si un campo es inválido
  isFieldInvalid(controlName: string): boolean {
    const control = this.driversForm.get(controlName);
    return !!(control && control.invalid && control.touched);
  }

  // Método para verificar si un campo es requerido
  isFieldRequired(controlName: string): boolean {
    const control = this.driversForm.get(controlName);
    return !!(
      control &&
      control.validator &&
      control.validator(control)?.required
    );
  }

  // Método para mostrar errores de validación
  showValidationErrors(): void {
    if (this.driversForm) {
      this.driversForm.markAllAsTouched();
      // Forzar la detección de cambios
      Object.keys(this.driversForm.controls).forEach((key) => {
        const control = this.driversForm.get(key);
        if (control) {
          control.markAsTouched();
          control.updateValueAndValidity();
        }
      });
    }
  }

  changeTypeDocument(
    value: string | null | undefined,
    isEdit: boolean = false
  ) {
    this.updateDocumentValidators(value);
    // Solo limpiar el valor si no es modo edición
    if (!isEdit) {
      this.driversForm.controls['dni'].setValue('');
    }
  }

  onSubmit(): void {
    console.log('============ onSubmit ');

    if (this.driversForm.value.dni) {
      this.driversForm.value.dni = ('' + this.driversForm.value.dni).trim();
    }

    if (this.driversForm.invalid) {
      this.driversForm.markAllAsTouched();
      Swal.fire({
        title: 'Error',
        text: 'Por favor, complete todos los campos obligatorios correctamente',
        icon: 'error',
      });
      return;
    }

    if (this.driversForm.value.nro_cipia == '--') {
      this.driversForm.value.nro_cipia = null;
    }
    if (this.driversForm.value.nro_llave == '--') {
      this.driversForm.value.nro_llave = null;
    }

    Swal.fire({
      //title: '¿Desea guardar los cambios?',
      text: '¿Desea guardar los cambios?',
      icon: 'question',
      showLoaderOnConfirm: true,
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: 'Guardar',
      cancelButtonText: 'Cancelar',
      preConfirm: async () => {
        console.log(this.driversForm.value);
        var res: any;
        if (this.driversService.action == 'edit') {
          res = await this.driversService.edit(this.driversForm.value);
        } else {
          res = await this.driversService.create(this.driversForm.value);
        }
        console.log('response->', res);

        if (res.success == false) {
          Swal.fire('', res.msn, 'warning');
        } else if (res.success == true) {
          if (res.text == 'Insert') {
            Swal.fire('', 'Conductor se registro correctamente.', 'success');
            this.driversService.modalActive = false;
            this.driversService.spinner.show('loadingDrivers');
            this.driversService.initialize();
            // if(res.dataInsert.tipo_identificacion.vehicle == true){
            //   this.VehicleService.updateDriverAndId(res.dataInsert,true);
            // }
          } else if (res.text == 'Update') {
            Swal.fire('', res.msn, 'success');
            this.driversService.modalActive = false;
            this.driversService.spinner.show('loadingDrivers');
            this.driversService.initialize();
            // if(res.driver.tipo_identificacion.vehicle == true || res.driverOld.tipo_identificacion.vehicle == true){
            //   //VERIFICAR IMEI IGUALEs
            //   if(res.driverOld.tracker_imei == res.driver.tracker_imei){
            //     // console.log('IMEI IGUALES SOLO ACTUALIZAR UNO');
            //     this.VehicleService.updateDriverAndId(res.driver,true);
            //   }else {
            //     // console.log('IMEI NO IGUALES SOLO ACTUALIZAR UNO');
            //     if (res.driverOld.tipo_identificacion.vehicle == true){
            //       // console.log('UPDATE OLD',res.driverOld);
            //       this.VehicleService.updateDriverAndId(res.driverOld,false); // SI ES FALSE ELIMINA
            //     }
            //     if(res.driver.tipo_identificacion.vehicle == true){
            //       // console.log('UPDATE NEW',res.driver);
            //       this.VehicleService.updateDriverAndId(res.driver,true);
            //     }
            //   }
            // }
          }
        } else {
          console.log('------------ CASO NO DETECTED');
        }
      },
    }).then((data) => {
      // console.log(data);
    });
  }
}
